import { render, staticRenderFns } from "./ToolFavoriteButton.vue?vue&type=template&id=5ba74b5c&"
import script from "./ToolFavoriteButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./ToolFavoriteButton.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports